import { ReactComponent as RusLogo } from "../../assets/logos/rus_svg.svg";
import { ReactComponent as SancorLogo } from "../../assets/logos/sancor_svg.svg";
import { ReactComponent as TerrawindLogo } from "../../assets/logos/terrawind_black.svg";
import { ReactComponent as ZurichLogo } from "../../assets/logos/zurich_svg.svg";
import { ReactComponent as FedPatLogo } from "../../assets/logos/federacion_patronal_logo.svg";
import { ReactComponent as ExpertaLogo } from "../../assets/logos/experta_logo.svg";
import "./CompanyLogo.css";

const companiesLogos = {
    "Sancor": <SancorLogo className="CompanyLogo__logo --sancor"/>,
    "RUS": <RusLogo className="CompanyLogo__logo"/>,
    "Zurich": <ZurichLogo className="CompanyLogo__logo"/>,
    "Terrawind": <TerrawindLogo className="CompanyLogo__logo --terrawind"/>,
    "Federacion_Patronal": <FedPatLogo className="CompanyLogo__logo"/>,
    "Experta": <ExpertaLogo className="CompanyLogo__logo --experta"/>
}

const CompanyLogo = ({ company }) => {
    return (
        <div className="CompanyLogo__container">
            {companiesLogos[company]}
        </div>
    );
}

export default CompanyLogo;
